var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeelam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 100,
    viewBox: "0 0 118 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1385_145291",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 7,
    width: 37,
    height: 59
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "d29b4ae791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.4385 7.1416H86.267V65.0406H50.4385V7.1416Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1385_145291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M76.81 47.1124L50.4614 31.8915V44.3587L86.2695 65.0433V7.43945H76.81V47.1124Z",
    fill: "#B29E84"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1385_145291",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 0,
    width: 37,
    height: 58
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "6fe5a0b491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.5591 0H68.8342V57.7296H32.5591V0Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1385_145291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.5591 -0.00292969V57.6035H42.0186V17.928L68.3645 33.1489V20.6817L32.5591 -0.00292969Z",
    fill: "#253439"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.87793 99.9488V95.0625H1.82234V99.9488H0.87793Z",
    fill: "#423E3A"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.00056 96.8179V99.9488H4.05615V95.0625H4.78499L7.33079 98.2755V95.0728H8.28547V99.9488H7.51557L5.00056 96.8179Z",
    fill: "#423E3A"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.5151 99.9488V95.0625H12.2808C12.6837 95.0625 13.0327 95.1292 13.3278 95.2575C13.6281 95.3884 13.877 95.5629 14.0772 95.7811C14.2825 96.0018 14.4365 96.261 14.5391 96.5612C14.6418 96.8564 14.6931 97.1669 14.6931 97.4954C14.6931 97.8726 14.6341 98.2114 14.5186 98.5116C14.4083 98.8145 14.2466 99.0711 14.0361 99.2815C13.8231 99.4946 13.5691 99.6588 13.2765 99.7743C12.9814 99.8923 12.6503 99.9488 12.2808 99.9488H10.5151ZM13.7384 97.4954C13.7384 97.2644 13.7025 97.0514 13.6358 96.8589C13.5742 96.6613 13.4818 96.4894 13.3586 96.3457C13.2354 96.202 13.0815 96.0942 12.8967 96.0172C12.717 95.9351 12.5117 95.894 12.2808 95.894H11.4595V99.1173H12.2808C12.5194 99.1173 12.7273 99.0762 12.907 98.9941C13.0917 98.912 13.2406 98.7991 13.3586 98.6554C13.4818 98.5116 13.5742 98.3423 13.6358 98.1421C13.7025 97.9445 13.7384 97.7289 13.7384 97.4954Z",
    fill: "#423E3A"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.7143 99.1481C18.9324 99.1481 19.1172 99.1045 19.2686 99.0147C19.4252 98.9197 19.5509 98.7991 19.6484 98.6554C19.7434 98.5065 19.8075 98.3346 19.8435 98.1421C19.8845 97.9522 19.9051 97.7571 19.9051 97.557V95.0625H20.8495V97.557C20.8495 97.8932 20.8084 98.2088 20.7263 98.5014C20.6442 98.7965 20.5159 99.0531 20.3465 99.2713C20.1745 99.492 19.9513 99.6665 19.6792 99.7948C19.4123 99.918 19.089 99.9796 18.7143 99.9796C18.3242 99.9796 17.9906 99.9154 17.7186 99.7846C17.4517 99.6485 17.2309 99.4715 17.0616 99.2508C16.8896 99.0249 16.7664 98.7657 16.692 98.4706C16.615 98.178 16.5791 97.8726 16.5791 97.557V95.0625H17.5235V97.557C17.5235 97.7623 17.544 97.9625 17.5851 98.1524C17.6262 98.3448 17.6903 98.5116 17.7801 98.6554C17.8751 98.7991 17.9983 98.9197 18.1497 99.0147C18.2985 99.1045 18.4885 99.1481 18.7143 99.1481Z",
    fill: "#423E3A"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M25.9255 96.3452C25.8896 96.3118 25.8331 96.2682 25.751 96.2118C25.6689 96.1579 25.5662 96.1065 25.443 96.0578C25.3199 96.0039 25.1864 95.9603 25.0427 95.9243C24.899 95.8833 24.7553 95.8627 24.6115 95.8627C24.3498 95.8627 24.1547 95.9115 24.0264 96.0065C23.8955 96.104 23.8314 96.24 23.8314 96.4171C23.8314 96.5146 23.8545 96.5967 23.9032 96.6634C23.9494 96.7327 24.0187 96.7943 24.1085 96.8482C24.2035 96.897 24.319 96.9406 24.4576 96.9817C24.6013 97.0227 24.7655 97.0638 24.9503 97.1048C25.189 97.1741 25.4045 97.246 25.597 97.3204C25.7946 97.3897 25.9589 97.4795 26.0898 97.5873C26.2258 97.6977 26.331 97.8311 26.408 97.9877C26.4824 98.1391 26.5209 98.3264 26.5209 98.5523C26.5209 98.814 26.4696 99.0347 26.3669 99.2195C26.2694 99.4043 26.1359 99.5557 25.9666 99.6712C25.8023 99.7892 25.6098 99.8739 25.3917 99.9278C25.171 99.974 24.9426 99.9997 24.7039 99.9997C24.3395 99.9997 23.9777 99.9458 23.6158 99.8354C23.2591 99.7276 22.9409 99.5737 22.6611 99.3735L23.082 98.5523C23.1231 98.5933 23.1949 98.6498 23.2976 98.7165C23.4054 98.7781 23.5337 98.8448 23.6774 98.9115C23.8262 98.9808 23.9905 99.0399 24.1701 99.0861C24.3472 99.1271 24.532 99.1476 24.7245 99.1476C25.2429 99.1476 25.5046 98.9808 25.5046 98.6446C25.5046 98.542 25.4738 98.4573 25.4122 98.388C25.3558 98.3136 25.2737 98.2494 25.1659 98.193C25.0555 98.1314 24.9221 98.0801 24.7655 98.039C24.6064 97.9928 24.4319 97.9415 24.242 97.885C24.0085 97.8234 23.8032 97.7567 23.6261 97.6797C23.4541 97.6053 23.3104 97.5155 23.1949 97.4128C23.0846 97.305 22.9999 97.1844 22.9383 97.0535C22.8818 96.9175 22.8562 96.7533 22.8562 96.5608C22.8562 96.3144 22.8998 96.0963 22.9896 95.9038C23.0846 95.7139 23.2155 95.5522 23.3797 95.4213C23.544 95.293 23.7313 95.1955 23.9443 95.1339C24.1624 95.0672 24.396 95.0312 24.6423 95.0312C24.9837 95.0312 25.2993 95.0877 25.5868 95.1955C25.8742 95.2981 26.1257 95.4265 26.3464 95.5753L25.9255 96.3452Z",
    fill: "#423E3A"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M32.0919 95.894H30.5316V99.9488H29.5872V95.894H28.0269V95.0625H32.0919V95.894Z",
    fill: "#423E3A"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.9165 99.9488V95.0625H36.0722C36.2981 95.0625 36.5034 95.1113 36.6881 95.2062C36.8781 95.3037 37.0423 95.4295 37.1809 95.586C37.3246 95.7374 37.4324 95.912 37.5094 96.1096C37.5838 96.302 37.6223 96.4945 37.6223 96.6844C37.6223 97.0078 37.5427 97.2978 37.3862 97.557C37.2271 97.811 37.0166 97.9958 36.7497 98.1113L37.8584 99.9488H36.7908L35.7951 98.3166H34.8609V99.9488H33.9165ZM34.8609 97.4749H36.0517C36.1389 97.4749 36.2211 97.4543 36.2981 97.4133C36.3725 97.3722 36.4366 97.3183 36.4931 97.249C36.547 97.1823 36.5881 97.1002 36.6163 97.0026C36.6496 96.9077 36.6676 96.8025 36.6676 96.6844C36.6676 96.5766 36.6496 96.474 36.6163 96.3765C36.5804 96.2815 36.529 96.1994 36.4623 96.1301C36.4007 96.0557 36.3289 95.9966 36.2467 95.9556C36.1697 95.9145 36.0928 95.894 36.0106 95.894H34.8609V97.4749Z",
    fill: "#423E3A"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M39.7012 99.9488V95.0625H40.6456V99.9488H39.7012Z",
    fill: "#423E3A"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M44.2653 95.0625H45.107L46.965 99.9488H45.9796L45.5279 98.7272H43.8239L43.3722 99.9488H42.397L44.2653 95.0625ZM45.3534 98.06L44.6861 96.1404L43.9778 98.06H45.3534Z",
    fill: "#423E3A"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M48.7129 99.9488V95.0625H49.6573V99.1173H52.1518V99.9488H48.7129Z",
    fill: "#423E3A"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M56.5049 97.4749C56.5049 97.1746 56.5562 96.8795 56.6589 96.5921C56.7666 96.2995 56.9258 96.0377 57.1311 95.8119C57.3415 95.5809 57.5956 95.3961 57.8907 95.2576C58.191 95.1138 58.5297 95.042 58.907 95.042C59.3586 95.042 59.7487 95.1421 60.0772 95.3397C60.4057 95.5322 60.6469 95.7862 60.8061 96.0993L60.0772 96.6023C60.0156 96.4663 59.9361 96.3534 59.8411 96.2636C59.7513 96.1686 59.6512 96.0942 59.5434 96.0377C59.4408 95.9838 59.3304 95.9428 59.2149 95.9145C59.1046 95.8889 58.9942 95.8735 58.8864 95.8735C58.6452 95.8735 58.4373 95.9248 58.2603 96.0275C58.0806 96.125 57.9343 96.2482 57.8188 96.397C57.7008 96.5484 57.6135 96.7229 57.5519 96.9205C57.4955 97.113 57.4698 97.3055 57.4698 97.4954C57.4698 97.7161 57.5032 97.924 57.5725 98.1216C57.6392 98.3218 57.7367 98.4963 57.8599 98.6451C57.9882 98.7965 58.1396 98.9197 58.3116 99.0147C58.4887 99.1045 58.6837 99.1481 58.8967 99.1481C59.0045 99.1481 59.1174 99.1353 59.2355 99.1071C59.3586 99.0814 59.4716 99.0403 59.5742 98.9839C59.682 98.9223 59.7821 98.8453 59.8719 98.7478C59.9669 98.6528 60.0413 98.5399 60.0977 98.409L60.8779 98.8504C60.7958 99.0352 60.6829 99.1995 60.5392 99.3432C60.3954 99.4817 60.2312 99.5972 60.0464 99.6922C59.8668 99.7897 59.6769 99.8641 59.4716 99.918C59.2663 99.9642 59.0635 99.9899 58.8659 99.9899C58.5169 99.9899 58.1987 99.918 57.9112 99.7743C57.6238 99.6255 57.3723 99.433 57.1619 99.1995C56.9566 98.9608 56.7949 98.6913 56.6794 98.3885C56.5613 98.0882 56.5049 97.7828 56.5049 97.4749Z",
    fill: "#423E3A"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M64.8156 99.9791C64.4512 99.9791 64.1227 99.9124 63.8302 99.7738C63.5427 99.6301 63.2912 99.4453 63.0808 99.2195C62.8755 98.9885 62.7138 98.7242 62.5983 98.4291C62.488 98.1288 62.4341 97.8209 62.4341 97.5052C62.4341 97.1844 62.4905 96.8739 62.6086 96.571C62.7318 96.2708 62.8986 96.0065 63.1116 95.7806C63.3297 95.5496 63.5838 95.3674 63.8712 95.2366C64.1638 95.1005 64.4871 95.0312 64.8362 95.0312C65.1852 95.0312 65.5034 95.1031 65.7908 95.2468C66.0834 95.3905 66.3349 95.583 66.5402 95.8217C66.7507 96.0552 66.9123 96.3221 67.0227 96.6224C67.1382 96.9175 67.1972 97.2152 67.1972 97.5155C67.1972 97.8439 67.1356 98.157 67.0124 98.4496C66.8944 98.7447 66.7301 99.0091 66.5197 99.24C66.3144 99.4659 66.0629 99.6481 65.7703 99.7841C65.4752 99.915 65.157 99.9791 64.8156 99.9791ZM63.399 97.5052C63.399 97.7182 63.4298 97.9235 63.4914 98.1211C63.553 98.3213 63.6454 98.4958 63.7686 98.6446C63.8918 98.7961 64.038 98.9192 64.21 99.0142C64.3871 99.104 64.5898 99.1476 64.8156 99.1476C65.0466 99.1476 65.2493 99.1015 65.4213 99.0039C65.5984 98.909 65.7498 98.7858 65.873 98.6344C65.9962 98.4778 66.0885 98.3033 66.1501 98.1108C66.2117 97.9132 66.2425 97.7105 66.2425 97.5052C66.2425 97.2948 66.2066 97.092 66.1399 96.8995C66.0783 96.7019 65.9859 96.5274 65.8627 96.376C65.7395 96.2195 65.5881 96.0963 65.411 96.0065C65.2314 95.9192 65.0338 95.873 64.8156 95.873C64.5898 95.873 64.3845 95.9218 64.1997 96.0167C64.0201 96.1142 63.8738 96.24 63.7583 96.3965C63.6403 96.548 63.553 96.7225 63.4914 96.9201C63.4298 97.1125 63.399 97.3076 63.399 97.5052Z",
    fill: "#423E3A"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M69.1426 99.9488V95.0625H71.2983C71.5241 95.0625 71.7294 95.1113 71.9142 95.2062C72.1041 95.3037 72.2684 95.4295 72.407 95.586C72.5507 95.7374 72.6585 95.912 72.7354 96.1096C72.8099 96.302 72.8484 96.4945 72.8484 96.6844C72.8484 97.0078 72.7688 97.2978 72.6123 97.557C72.4531 97.811 72.2427 97.9958 71.9758 98.1113L73.0845 99.9488H72.0169L71.0211 98.3166H70.087V99.9488H69.1426ZM70.087 97.4749H71.2778C71.365 97.4749 71.4471 97.4543 71.5241 97.4133C71.5986 97.3722 71.6627 97.3183 71.7192 97.249C71.7731 97.1823 71.8141 97.1002 71.8424 97.0026C71.8757 96.9077 71.8937 96.8025 71.8937 96.6844C71.8937 96.5766 71.8757 96.474 71.8424 96.3765C71.8064 96.2815 71.7551 96.1994 71.6884 96.1301C71.6268 96.0557 71.5549 95.9966 71.4728 95.9556C71.3958 95.9145 71.3188 95.894 71.2367 95.894H70.087V97.4749Z",
    fill: "#423E3A"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M74.9277 99.9488V95.0625H76.9911C77.2169 95.0625 77.4248 95.1113 77.6172 95.2062C77.8072 95.3037 77.9714 95.4295 78.11 95.586C78.246 95.7374 78.3512 95.912 78.4282 96.1096C78.5103 96.302 78.5514 96.4945 78.5514 96.6844C78.5514 96.8974 78.5129 97.1027 78.4385 97.3003C78.3615 97.4928 78.2563 97.6648 78.1203 97.8136C77.9894 97.965 77.8277 98.0882 77.6378 98.1832C77.453 98.273 77.2503 98.3166 77.0321 98.3166H75.8721V99.9488H74.9277ZM75.8721 97.4749H76.9705C77.1476 97.4749 77.2939 97.4081 77.4119 97.2695C77.5274 97.1258 77.5865 96.9308 77.5865 96.6844C77.5865 96.5612 77.5659 96.4535 77.5249 96.3559C77.4889 96.261 77.4427 96.1789 77.3811 96.1096C77.3247 96.0351 77.258 95.9812 77.1758 95.9453C77.0937 95.912 77.0116 95.894 76.9295 95.894H75.8721V97.4749Z",
    fill: "#423E3A"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M82.5075 99.9791C82.1431 99.9791 81.8146 99.9124 81.5221 99.7738C81.2346 99.6301 80.9831 99.4453 80.7727 99.2195C80.5674 98.9885 80.4057 98.7242 80.2902 98.4291C80.1799 98.1288 80.126 97.8209 80.126 97.5052C80.126 97.1844 80.1824 96.8739 80.3005 96.571C80.4237 96.2708 80.5905 96.0065 80.8035 95.7806C81.0216 95.5496 81.2757 95.3674 81.5631 95.2366C81.8557 95.1005 82.179 95.0312 82.5281 95.0312C82.8771 95.0312 83.1953 95.1031 83.4827 95.2468C83.7753 95.3905 84.0268 95.583 84.2321 95.8217C84.4425 96.0552 84.6042 96.3221 84.7146 96.6224C84.8301 96.9175 84.8891 97.2152 84.8891 97.5155C84.8891 97.8439 84.8275 98.157 84.7043 98.4496C84.5863 98.7447 84.422 99.0091 84.2116 99.24C84.0063 99.4659 83.7548 99.6481 83.4622 99.7841C83.1671 99.915 82.8489 99.9791 82.5075 99.9791ZM81.0909 97.5052C81.0909 97.7182 81.1217 97.9235 81.1833 98.1211C81.2449 98.3213 81.3373 98.4958 81.4605 98.6446C81.5837 98.7961 81.7299 98.9192 81.9019 99.0142C82.079 99.104 82.2817 99.1476 82.5075 99.1476C82.7385 99.1476 82.9412 99.1015 83.1132 99.0039C83.2903 98.909 83.4417 98.7858 83.5649 98.6344C83.688 98.4778 83.7804 98.3033 83.842 98.1108C83.9036 97.9132 83.9344 97.7105 83.9344 97.5052C83.9344 97.2948 83.8985 97.092 83.8318 96.8995C83.7702 96.7019 83.6778 96.5274 83.5546 96.376C83.4314 96.2195 83.28 96.0963 83.1029 96.0065C82.9233 95.9192 82.7257 95.873 82.5075 95.873C82.2817 95.873 82.0764 95.9218 81.8916 96.0167C81.712 96.1142 81.5657 96.24 81.4502 96.3965C81.3322 96.548 81.2449 96.7225 81.1833 96.9201C81.1217 97.1125 81.0909 97.3076 81.0909 97.5052Z",
    fill: "#423E3A"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M86.8345 99.9488V95.0625H88.9902C89.216 95.0625 89.4213 95.1113 89.6061 95.2062C89.796 95.3037 89.9603 95.4295 90.0988 95.586C90.2426 95.7374 90.3503 95.912 90.4273 96.1096C90.5018 96.302 90.5403 96.4945 90.5403 96.6844C90.5403 97.0078 90.4607 97.2978 90.3042 97.557C90.145 97.811 89.9346 97.9958 89.6677 98.1113L90.7764 99.9488H89.7088L88.713 98.3166H87.7789V99.9488H86.8345ZM87.7789 97.4749H88.9697C89.0569 97.4749 89.139 97.4543 89.216 97.4133C89.2905 97.3722 89.3546 97.3183 89.4111 97.249C89.465 97.1823 89.506 97.1002 89.5343 97.0026C89.5676 96.9077 89.5856 96.8025 89.5856 96.6844C89.5856 96.5766 89.5676 96.474 89.5343 96.3765C89.4983 96.2815 89.447 96.1994 89.3803 96.1301C89.3187 96.0557 89.2468 95.9966 89.1647 95.9556C89.0877 95.9145 89.0107 95.894 88.9286 95.894H87.7789V97.4749Z",
    fill: "#423E3A"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M94.0055 95.0625H94.8473L96.7053 99.9488H95.7198L95.2681 98.7272H93.5641L93.1124 99.9488H92.1372L94.0055 95.0625ZM95.0936 98.06L94.4264 96.1404L93.7181 98.06H95.0936Z",
    fill: "#423E3A"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M102.097 95.894H100.536V99.9488H99.5921V95.894H98.0317V95.0625H102.097V95.894Z",
    fill: "#423E3A"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M103.921 99.9488V95.0625H104.866V99.9488H103.921Z",
    fill: "#423E3A"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M109.183 99.9791C108.819 99.9791 108.49 99.9124 108.198 99.7738C107.91 99.6301 107.659 99.4453 107.448 99.2195C107.243 98.9885 107.081 98.7242 106.966 98.4291C106.856 98.1288 106.802 97.8209 106.802 97.5052C106.802 97.1844 106.858 96.8739 106.976 96.571C107.099 96.2708 107.266 96.0065 107.479 95.7806C107.697 95.5496 107.951 95.3674 108.239 95.2366C108.531 95.1005 108.855 95.0312 109.204 95.0312C109.553 95.0312 109.871 95.1031 110.159 95.2468C110.451 95.3905 110.703 95.583 110.908 95.8217C111.118 96.0552 111.28 96.3221 111.39 96.6224C111.506 96.9175 111.565 97.2152 111.565 97.5155C111.565 97.8439 111.503 98.157 111.38 98.4496C111.262 98.7447 111.098 99.0091 110.887 99.24C110.682 99.4659 110.431 99.6481 110.138 99.7841C109.843 99.915 109.525 99.9791 109.183 99.9791ZM107.767 97.5052C107.767 97.7182 107.797 97.9235 107.859 98.1211C107.921 98.3213 108.013 98.4958 108.136 98.6446C108.259 98.7961 108.406 98.9192 108.578 99.0142C108.755 99.104 108.957 99.1476 109.183 99.1476C109.414 99.1476 109.617 99.1015 109.789 99.0039C109.966 98.909 110.117 98.7858 110.241 98.6344C110.364 98.4778 110.456 98.3033 110.518 98.1108C110.579 97.9132 110.61 97.7105 110.61 97.5052C110.61 97.2948 110.574 97.092 110.508 96.8995C110.446 96.7019 110.354 96.5274 110.23 96.376C110.107 96.2195 109.956 96.0963 109.779 96.0065C109.599 95.9192 109.401 95.873 109.183 95.873C108.957 95.873 108.752 95.9218 108.567 96.0167C108.388 96.1142 108.241 96.24 108.126 96.3965C108.008 96.548 107.921 96.7225 107.859 96.9201C107.797 97.1125 107.767 97.3076 107.767 97.5052Z",
    fill: "#423E3A"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M114.455 96.8179V99.9488H113.51V95.0625H114.239L116.785 98.2755V95.0728H117.74V99.9488H116.97L114.455 96.8179Z",
    fill: "#423E3A"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M25.2295 75.6807V88.0812H22.8787L16.6887 80.5464V88.0812H13.8555V75.6807H16.237L22.3962 83.2051V75.6807H25.2295Z",
    fill: "#423E3A"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M39.3662 85.7817V88.0812H29.7578V75.6807H39.1301V77.9801H32.6116V80.6799H38.3704V82.9075H32.6116V85.7817H39.3662Z",
    fill: "#423E3A"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M52.8427 85.7817V88.0812H43.2344V75.6807H52.6066V77.9801H46.0881V80.6799H51.847V82.9075H46.0881V85.7817H52.8427Z",
    fill: "#423E3A"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M56.7109 75.6807H59.5852V85.7407H65.806V88.0812H56.7109V75.6807Z",
    fill: "#423E3A"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M77.1725 85.4225H71.4137L70.3153 88.0812H67.3691L72.9022 75.6807H75.7354L81.2787 88.0812H78.2709L77.1725 85.4225ZM76.2692 83.2462L74.2982 78.4934L72.3376 83.2462H76.2692Z",
    fill: "#423E3A"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M95.4515 88.0812L95.431 80.6388L91.7765 86.7672H90.4831L86.8594 80.8031V88.0812H84.1597V75.6807H86.5412L91.1812 83.3899L95.7492 75.6807H98.1102L98.141 88.0812H95.4515Z",
    fill: "#423E3A"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeelam);
export default __webpack_public_path__ + "static/media/neelam.15b0564e1e4a3d18e95b2865d10302d7.svg";
export { ForwardRef as ReactComponent };